import { defaultModalOptions } from '@/constants/modal-options'
import { ModalType } from '@/enums/modal-type'
import { Modal, type ModalOptions } from 'flowbite'

class ModalHelperService {
  constructor() {}

  private readonly modal = new Map<ModalType, Modal>()

  public init(
    type: ModalType,
    ref: HTMLDivElement,
    options: ModalOptions = defaultModalOptions
  ): void {
    this.modal.set(type, new Modal(ref, options))
  }

  public show(type: ModalType) {
    if (this.modal.has(type)) {
      const modal = this.modal.get(type)
      if (modal) {
        modal.show()
      }
    }
  }

  public getModalByType(type: ModalType) {
    return this.modal.get(type)
  }

  public hide(type: ModalType) {
    if (this.modal.has(type)) {
      const modal = this.modal.get(type)
      if (modal) {
        modal.hide()
      }
    }
  }
}
export default new ModalHelperService()
